angular.module('impactx.product').controller('RecentlyViewedProductsCtrl', [
    '$scope',
    'dataGen',
    'ToolbarService',
    RecentlyViewedProductsCtrl
]);

function RecentlyViewedProductsCtrl($scope, dataGen, ToolbarService) {
    ToolbarService.setButtons([]);
    dataGen.getData($scope, {}, '/product/recentlyviewed');
}